import { render, staticRenderFns } from "./SwimpoolCoverPanelMaterials.vue?vue&type=template&id=ca9174e2&scoped=true"
import script from "./SwimpoolCoverPanelMaterials.vue?vue&type=script&lang=ts"
export * from "./SwimpoolCoverPanelMaterials.vue?vue&type=script&lang=ts"
import style0 from "./SwimpoolCoverPanelMaterials.vue?vue&type=style&index=0&id=ca9174e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9174e2",
  null
  
)

export default component.exports